import React from 'react'
import validator from 'validator'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import { FormSection } from './FormKit'

const FIELDS = [
  { label: 'Full name', field: 'fullName', required: true, sm: 6 },
  { label: 'Email', field: 'email', required: true, sm: 6, type: 'email' },
  { label: 'Phone number', field: 'phoneNumber', sm: 6, type: 'tel' },
  {
    label: 'Relationship to you',
    field: 'relationship',
    helperText: 'e.g. line manager, colleague',
    sm: 6,
  },
  { label: 'Company', field: 'company', sm: 6 },
  { label: 'Their position / role', field: 'position', sm: 6 },
  { label: 'How long have they known you?', field: 'duration', sm: 12 },
  {
    label: 'Comments',
    field: 'comments',
    helperText: 'Optional — anything else we should know',
    sm: 12,
    multiline: true,
  },
]

const References = ({ formValues, setFormValues }) => (
  <Stack gap={2}>
    <Alert severity="info" icon={false}>
      Please give two professional referees, such as previous employers or
      colleagues. If you're applying for a healthcare role, one must be from
      your most recent healthcare employer, as the Care Quality Commission
      (CQC) requires.
    </Alert>
    {['reference1', 'reference2'].map((number, index) => {
      const reference = formValues?.[number] ?? {}
      const locked = !!reference.emailSent
      return (
        <FormSection
          key={number}
          title={`Referee ${index + 1}`}
          caption={
            locked
              ? "We've already contacted this referee, so their details can't be changed."
              : undefined
          }
        >
          <Grid container spacing={2}>
            {FIELDS.map(
              ({ label, field, helperText, required, sm, type, multiline }) => {
                const emailInvalid =
                  field === 'email' &&
                  !!reference.email &&
                  !validator.isEmail(reference.email.trim())
                return (
                  <Grid item xs={12} sm={sm} key={field}>
                    <TextField
                      label={label}
                      size="small"
                      fullWidth
                      type={type}
                      required={required}
                      autoComplete="off"
                      disabled={locked}
                      name={number + '-' + field}
                      value={reference[field] ?? ''}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          [number]: { ...prev[number], [field]: e.target.value },
                        }))
                      }
                      multiline={multiline}
                      minRows={multiline ? 2 : undefined}
                      error={emailInvalid}
                      helperText={
                        emailInvalid ? 'Check this email address' : helperText
                      }
                    />
                  </Grid>
                )
              },
            )}
          </Grid>
        </FormSection>
      )
    })}
  </Stack>
)

export default References
